<template>
<div class="content2">
  <div class="header">
    <el-date-picker
      style="width: 120px"
      v-model="where2.year_month"
      size="mini"
      type="month"
      format="yyyy-MM"
      value-format="yyyy-MM" placeholder="选择月份">
    </el-date-picker>
    <el-button @click="exportExcel">导出报表</el-button>
  </div>
  <div class="body">
    <div class="table-wrap">
      <el-table
        v-loading="loading"
        v-if="tableData" :data="tableData"
        :span-method="objectSpanMethod"
        border class="table-wrap-table" height="60vh">
        <el-table-column label="名称" prop="name" align="center" width="180" fixed="left"></el-table-column>
        <el-table-column label="1至2年欠费" align="center">
          <el-table-column label="户数" prop="one_count" align="center" width="100" :formatter="intMilFormatter"></el-table-column>
          <el-table-column label="金额" prop="one_amount" align="center" width="100" :formatter="milFormatter"></el-table-column>
        </el-table-column>
        <el-table-column label="2年以上欠费" align="center">
          <el-table-column label="户数" prop="two_count" align="center" width="100" :formatter="intMilFormatter"></el-table-column>
          <el-table-column label="金额" prop="two_amount" align="center" width="100" :formatter="milFormatter"></el-table-column>
        </el-table-column>
        <el-table-column label="1年以上欠费" align="center">
          <el-table-column label="户数" prop="one_two_count" align="center" width="100" :formatter="intMilFormatter">
            <template slot-scope="scope">
              <el-tooltip content="1年以上欠费户数=1年到2年欠费户数+2年以上欠费户数" placement="top">
                <span>{{formatMoney(scope.row.one_two_count)}}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column label="金额" prop="one_two_amount" align="center" width="100" :formatter="milFormatter">
            <template slot-scope="scope">
              <el-tooltip content="1年以上欠费金额=1年到2年欠费金额+2年以上欠费金额" placement="top">
                <span>{{formatMoney(scope.row.one_two_amount,2)}}</span>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table-column>

        <el-table-column :label="month+'月年度诉讼计划'" align="center">
          <el-table-column label="户数" prop="year_plan_count" align="center" width="100" :formatter="intMilFormatter"></el-table-column>
          <el-table-column label="金额" prop="year_plan_amount" align="center" width="100" :formatter="milFormatter"></el-table-column>
        </el-table-column>

        <el-table-column label="诉讼比例" align="center">
          <el-table-column label="户数" prop="plan_count_rate" align="center" width="100">
            <template slot-scope="scope">
              <el-tooltip content="诉讼比例=月调整后诉讼计划/一年以上欠费户数" placement="top">
                <span>{{scope.row.plan_count_rate}}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column label="金额" prop="plan_amount_rate" align="center" width="100">
            <template slot-scope="scope">
              <el-tooltip content="诉讼比例=月调整后诉讼计划/一年以上欠费金额" placement="top">
                <span>{{scope.row.plan_amount_rate}}</span>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column :label="month+'月调整后诉讼计划'" align="center">
          <el-table-column label="户数" prop="plan_count_cur" align="center" width="100" :formatter="intMilFormatter"></el-table-column>
          <el-table-column label="金额" prop="plan_amount_cur" align="center" width="100" :formatter="milFormatter"></el-table-column>
        </el-table-column>
        <el-table-column :label="month+'月实际'" align="center">
          <el-table-column label="提交" align="center">
            <el-table-column label="项目自诉" prop="o_tj_count" align="center" width="100" :formatter="intMilFormatter"></el-table-column>
            <el-table-column label="三方诉讼" prop="t_tj_count" align="center" width="100" :formatter="intMilFormatter"></el-table-column>
          </el-table-column>
          <el-table-column label="诉调" align="center">
            <el-table-column label="项目自诉" prop="o_st_count" align="center" width="100" :formatter="intMilFormatter"></el-table-column>
            <el-table-column label="三方诉讼" prop="t_st_count" align="center" width="100" :formatter="intMilFormatter"></el-table-column>
          </el-table-column>
          <el-table-column label="立案" align="center">
            <el-table-column label="项目自诉" prop="o_la_count" align="center" width="100" :formatter="intMilFormatter"></el-table-column>
            <el-table-column label="三方诉讼" prop="t_la_count" align="center" width="100" :formatter="intMilFormatter"></el-table-column>
          </el-table-column>
          <el-table-column label="合计" align="center">
            <el-table-column label="提交合计" prop="total_tj_count" :formatter="intMilFormatter"></el-table-column>
            <el-table-column label="立案合计" prop="total_la_count" :formatter="intMilFormatter"></el-table-column>
          </el-table-column>
          <el-table-column label="提交率" prop="tj_rate" align="center" width="100">
            <template slot-scope="scope">
              <el-tooltip content="提交率=提交合计/月调整后诉讼计划" placement="top">
                <span>{{scope.row.tj_rate}}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column label="立案率" prop="la_rate" align="center" width="100">
            <template slot-scope="scope">
              <el-tooltip content="立案率=立案合计/月调整后诉讼计划" placement="top">
                <span>{{scope.row.la_rate}}</span>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="回款" align="center">
          <el-table-column label="户数" prop="hk_count" align="center" width="100" :formatter="intMilFormatter"></el-table-column>
          <el-table-column label="金额" prop="hk_amount" align="center" width="100" :formatter="milFormatter"></el-table-column>
        </el-table-column>
        <el-table-column :label="'1-'+month+'月调整后诉讼计划'" align="center">
          <el-table-column label="户数" prop="plan_count_tocur" align="center" width="100" :formatter="intMilFormatter"></el-table-column>
          <el-table-column label="金额" prop="plan_amount_tocur" align="center" width="100" :formatter="milFormatter"></el-table-column>
        </el-table-column>
        <el-table-column :label="'1-'+month+'月实际'" align="center">
          <el-table-column label="提交" align="center">
            <el-table-column label="项目自诉" prop="o_tj_count_tocur" align="center" width="100" :formatter="intMilFormatter"></el-table-column>
            <el-table-column label="三方诉讼" prop="t_tj_count_tocur" align="center" width="100" :formatter="intMilFormatter"></el-table-column>
          </el-table-column>

          <el-table-column label="诉调" align="center">
            <el-table-column label="项目自诉" prop="o_st_count_tocur" align="center" width="100" :formatter="intMilFormatter"></el-table-column>
            <el-table-column label="三方诉讼" prop="t_st_count_tocur" align="center" width="100" :formatter="intMilFormatter"></el-table-column>
          </el-table-column>
          <el-table-column label="立案" align="center">
            <el-table-column label="项目自诉" prop="o_la_count_tocur" align="center" width="100" :formatter="intMilFormatter"></el-table-column>
            <el-table-column label="三方诉讼" prop="t_la_count_tocur" align="center" width="100" :formatter="intMilFormatter"></el-table-column>
          </el-table-column>
          <el-table-column label="合计" align="center">
            <el-table-column label="提交合计" prop="total_tj_count_tocur" align="center" width="100" :formatter="intMilFormatter"></el-table-column>
            <el-table-column label="立案合计" prop="total_la_count_tocur" align="center" width="100" :formatter="intMilFormatter"></el-table-column>
          </el-table-column>
          <el-table-column label="提交率" prop="tj_rate_tocur" align="center" width="100">
            <template slot-scope="scope">
              <el-tooltip content="提交率=提交累计/计划累计" placement="top">
                <span>{{scope.row.tj_rate_tocur}}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column label="立案率" prop="la_rate_tocur" align="center" width="100">
            <template slot-scope="scope">
              <el-tooltip content="立案率=立案累计/计划累计" placement="top">
                <span>{{scope.row.la_rate_tocur}}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column label="回款" align="center">
            <el-table-column label="户数" prop="hk_count_tocur" align="center" width="100" :formatter="intMilFormatter"></el-table-column>
            <el-table-column label="金额" prop="hk_amount_tocur" align="center" width="100" :formatter="milFormatter"></el-table-column>
          </el-table-column>
        </el-table-column>
      </el-table>
    </div>
<!--    <div class="pagination-wrap">-->
<!--      <el-pagination background layout="prev, pager, next" :total="pageData.total*1"-->
<!--                     :page-size="pageData.pageSize*1" :current-page="pageData.page*1"-->
<!--                     @current-change="pageChange"></el-pagination>-->
<!--    </div>-->
  </div>
</div>
</template>

<script>
import {CommonHelp} from "../../common/CommonHelp";
import ButlerHttp from "../../common/ButlerHttp";
import moment from "moment";

export default {
  name: "RecordFilingRateAndCollectionStatisticsTable",
  inject:['where','reginWhere'],
  data() {
    return{
      where2:{
        year_month:moment().format("YYYY-MM"),
      },
      month:moment().format("M"),
      loading:false,
      tableData: [],
      pageData:{
        list: [],
        total: 0,
        pageSize: 15,
        page: 1,
      },
    }
  },
  mounted() {
    const that=this;
    this.pageChange(1);
  },
  watch:{
    "reginWhere.type_id":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "reginWhere.project_region":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "reginWhere.project_name":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "reginWhere.area_id":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "where2.year_month":function (n,o) {
      const that=this;
      that.month=moment(n).format("M");
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
  },
  methods: {
    getList(){
      const that = this;
      that.loading = true;
      let where = {
        ...that.where2,
        project_ids:typeof that.reginWhere.project_ids==="string"?that.reginWhere.project_ids:'',
        project_id:that.reginWhere.project_name,
        area_id:that.reginWhere.area_id,
        level:that.reginWhere.level,
      }

      ButlerHttp.post("ProjectCollectionProceedingRegister/index2",{
        ...where,
        page: that.pageData.page,
        pageSize: that.pageData.pageSize
      }, res => {
        if (res.code) {
          that.tableData = res.data.list;
        }
        that.loading = false;
      })
    },
    pageChange(i) {
      const that=this;
      that.pageData.page = i;
      CommonHelp.debounce(()=>{
        that.getList()
      },500,that);

    },
    exportExcel(){
      const that=this;
      const loading=that.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      let where = {
        ...that.where2,
        project_ids:typeof that.reginWhere.project_ids==="string"?that.reginWhere.project_ids:'',
        project_id:that.reginWhere.project_name,
        area_id:that.reginWhere.area_id,
        level:that.reginWhere.level,
      }
      ButlerHttp.post("StatisticalTable/ProjectCollectionProceedingRegisterExcel",{
        ...where,
      },res => {
        loading.close()
        if (res.code) {
          window.open(res.data)
        }else {
          that.$message.error(res.msg);
        }
      })
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        const prevRow = this.tableData[rowIndex - 1];
        const currRow = row;

        if (prevRow && prevRow[column.property] === currRow[column.property]) {
          return { rowspan: 0, colspan: 0 };
        } else {
          let rowspan = 1;
          for (let i = rowIndex + 1; i < this.tableData.length; i++) {
            if (this.tableData[i][column.property] === currRow[column.property]) {
              rowspan++;
            } else {
              break;
            }
          }
          if (rowspan > 1) {
            return { rowspan: rowspan, colspan: 1 };
          }
        }
      }
    },
  }
}
</script>

<style lang="scss" scoped>
@import "../../common";
.content2{
  .header{
    padding-top: 5px;
    padding-bottom: 10px;
    position: sticky;
    top: 0;
    left: 0;
    right: 0;
    z-index: 10;
    background-color: #FFFFFF;
  }
  .header-tip{
    margin: 5px 0;
    padding: 5px 10px;
    background-color: #f56c6c;
    color: #FFFFFF;
    border-radius: 4px;
    display: flex;
    flex-direction: row;

    .header-tip-body{
      //width: 500px;
      margin-left: 50px;
      display: flex;
      flex-direction: row;
      //justify-content: space-between;
      .header-tip-body-item{
        margin-left: 50px;
        display: flex;
        flex-direction: row;
      }
    }
  }
  .pagination-wrap{
    margin-top: 10px;
    text-align: center;
  }

  >>>.el-table--border, .el-table--group{
    border: 1px solid #000000;
  }
  >>>.el-table td.el-table__cell, .el-table th.el-table__cell.is-leaf{
    border-bottom: 1px solid #000000;
  }
  >>>.el-table--border .el-table__cell, .el-table__body-wrapper .el-table--border.is-scrolling-left~.el-table__fixed{
    border-right: 1px solid #000000;
  }
  >>>.el-table td.el-table__cell, .el-table th.el-table__cell.is-leaf{
    border-bottom: 1px solid #000000;
  }
  >>>.el-table--border th.el-table__cell, .el-table__fixed-right-patch{
    border-bottom: 1px solid #000000;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Butler/components/report_forms/RecordFilingRateAndCollectionStatisticsTable.vue